import { TEST, FETCH_SURVEY_DEFINITION, UPDATE_TRANSLATION_STATUS, TRANSLATION_LIST } from "./design-store-constants";

const initialState = {
    test: "test123",
    surveyDefinitionData: {},
    showTranslationPage: false
};

const DesignReducer = (state = initialState, action) => {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload.test
            };
        case FETCH_SURVEY_DEFINITION:
            return {
                ...state,
                surveyDefinitionData: action.payload.surveyDefinitionData
            };
              case TRANSLATION_LIST:
            return {
                ...state,
                translationList: action.payload.translationList
            };
        case UPDATE_TRANSLATION_STATUS:
            return {
                ...state,
                showTranslationPage: action.payload.showTranslationPage
            };
        default:
            return state;
    }
};
const mergeTranslationsWithSurvey = (surveyDefinition, translations) => {
    if (!surveyDefinition || !translations) return surveyDefinition;
    
    // Create a deep copy
    const mergedSurvey = JSON.parse(JSON.stringify(surveyDefinition));
    
    // Handle both string and object translations
    const translationData = typeof translations === 'string' 
        ? JSON.parse(translations)
        : translations;
    
    const translationPages = translationData.pages || [];
    
    // Merge logic here...
       mergedSurvey.pages.forEach(page => {
        page.elements.forEach(question => {
            // Find matching translation
            const translation = translationPages.find(t => 
                t.id === question.id || t.tempId === question.tempId
            );
            
            if (translation?.translations) {
                // Merge translations
                question.translations = {
                    ...question.translations,
                    ...translation.translations
                };
                
                // Merge choices if they exist
                if (question.choices) {
                    question.choices.forEach(choice => {
                        const choiceTranslations = Object.entries(translation.translations)
                            .reduce((acc, [lang, trans]) => {
                                const translatedChoice = trans.choices?.find(c => 
                                    c.tempId === choice.tempId || 
                                    c.value === choice.value
                                );
                                if (translatedChoice) {
                                    acc[lang] = { text: translatedChoice.text };
                                }
                                return acc;
                            }, {});
                        
                        choice.translations = {
                            ...choice.translations,
                            ...choiceTranslations
                        };
                    });
                }
            }
        });
    });
    
    return mergedSurvey;
};

export default DesignReducer;
